import React, { useEffect, useState } from 'react';
import { Drawer, Form, Input, Button, message, Space } from 'antd';
import { CloseOutlined, RightOutlined, CheckOutlined } from '@ant-design/icons';
import RecommendSelectPackageDialog from './RecommendSelectPackageDialog';

const FUNNEL_COUNT = 4;

/**
 * 推荐位套餐漏斗 - 添加/编辑抽屉（固定4个漏斗位）
 * 真实项目：views/operation/recommended/components/AddFunnelDrawer.vue
 */
const RecommendFunnelDrawer = ({ open, editData, slotCode, appId, onCancel, onSuccess }) => {
    const [form] = Form.useForm();
    const [slots, setSlots] = useState(Array.from({ length: FUNNEL_COUNT }, () => ({ packageId: '', packageName: '' })));
    const [selectOpen, setSelectOpen] = useState(false);
    const [selectIndex, setSelectIndex] = useState(-1);
    const isEdit = !!editData;

    useEffect(() => {
        if (!open) return;
        form.resetFields();
        if (editData) {
            const config = editData.funnelConfig || editData.slots || [];
            setSlots(Array.from({ length: FUNNEL_COUNT }, (_, i) => ({
                packageId: config[i]?.packageId || '',
                packageName: config[i]?.packageName || '',
            })));
            form.setFieldsValue({ name: editData.name || '' });
        } else {
            setSlots(Array.from({ length: FUNNEL_COUNT }, () => ({ packageId: '', packageName: '' })));
        }
    }, [open, editData, form]);

    const handlePackageConfirm = (pkg) => {
        if (selectIndex < 0) return;
        setSlots(prev => prev.map((s, i) => (i === selectIndex ? { packageId: pkg.packageId, packageName: pkg.name } : s)));
    };

    const clearSlot = (index) => setSlots(prev => prev.map((s, i) => (i === index ? { packageId: '', packageName: '' } : s)));

    const handleSubmit = async () => {
        const values = await form.validateFields();
        if (!slotCode) { message.warning('请先选择推荐位'); return; }
        onSuccess({
            id: editData?.id,
            name: values.name,
            slotCode,
            appId,
            funnelConfig: slots.map((s, i) => ({ position: i + 1, packageId: s.packageId || '', packageName: s.packageName || '' })),
        });
        message.success(isEdit ? '编辑成功' : '添加成功');
    };

    return (
        <Drawer
            title={isEdit ? '编辑漏斗' : '添加漏斗'}
            width={500}
            open={open}
            onClose={onCancel}
            destroyOnClose
            maskClosable={false}
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                    <Button icon={<CloseOutlined />} onClick={onCancel}>取消</Button>
                    <Button type="primary" icon={<CheckOutlined />} onClick={handleSubmit}>确定</Button>
                </div>
            }
        >
            <Form form={form} layout="vertical">
                <Form.Item label="漏斗名称" name="name" rules={[{ required: true, message: '请输入漏斗名称' }]}>
                    <Input placeholder="请输入漏斗名称" maxLength={50} showCount />
                </Form.Item>

                <div style={{ marginTop: 8 }}>
                    <div style={{ fontSize: 14, color: '#303133', fontWeight: 600, marginBottom: 16 }}>漏斗配置（固定{FUNNEL_COUNT}个漏斗位）</div>
                    {slots.map((slot, index) => (
                        <div key={index} style={{ padding: 16, border: '1px solid #ebeef5', borderRadius: 8, marginBottom: 12 }}>
                            <div style={{ fontSize: 14, color: '#303133', fontWeight: 600, marginBottom: 12 }}>漏斗位 #{index + 1}</div>
                            <div
                                onClick={() => { setSelectIndex(index); setSelectOpen(true); }}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', border: '1px solid #dcdfe6', borderRadius: 4, cursor: 'pointer' }}
                            >
                                <span style={{ color: slot.packageName ? '#303133' : '#a8abb2', fontSize: 14 }}>{slot.packageName || '请选择套餐'}</span>
                                <Space size={4}>
                                    {slot.packageId && <CloseOutlined style={{ color: '#c0c4cc' }} onClick={e => { e.stopPropagation(); clearSlot(index); }} />}
                                    <RightOutlined style={{ color: '#c0c4cc', fontSize: 14 }} />
                                </Space>
                            </div>
                        </div>
                    ))}
                </div>
            </Form>

            <RecommendSelectPackageDialog
                open={selectOpen}
                onCancel={() => setSelectOpen(false)}
                onConfirm={handlePackageConfirm}
            />
        </Drawer>
    );
};

export default RecommendFunnelDrawer;
